// 合同信息
import { i18n } from '@/common/utils/i18n'
import ContractType from '@/pages/shopDetail/config/ContractType'
import ContractorTypeList from '@/pages/shopDetail/config/ContractorTypeList'
// import DidiAgreement from '@/pages/shopDetail/config/DidiAgreement'
import PartyaTitle from '@/pages/shopDetail/config/PartyaTitle'
import { get } from 'lodash-es'
import {
  getFormatTimeByBrowserTimezone
} from '@didi/elvish-lib-javascript'

const DeliveryType = {
  platform: 1, // 平台配送
  onself: 2, // 自配送
  both: 3 // 平台配送+自配送
}

function platformSupport (deliveryType) {
  let result = ''
  if (deliveryType === DeliveryType.onself) {
    result = i18n.gettext('不支持')
  } else {
    result = i18n.gettext('支持')
  }
  return result
}

function formatPercent (value) {
  let percentValue = ''
  if (value !== '') {
    percentValue = value + '%'
  }
  return percentValue
}

function onselfSupport (deliveryType) {
  let result = ''
  if (deliveryType === DeliveryType.platform) {
    result = i18n.gettext('不支持')
  } else {
    result = i18n.gettext('支持')
  }
  return result
}

export default (state) => {
  let contractInfo = get(state, 'currentContractorDetail.contractInfo', {})
  // let contractorInfo = get(state, 'currentContractorDetail.contractorInfo', {})
  return {
    title: i18n.gettext('合同信息'),
    content: [
      {
        title: i18n.gettext('合同类型'),
        content: ContractType.val2text(contractInfo.contractType)
      },
      {
        title: i18n.gettext('合同版本'),
        content: contractInfo.contractVersion
      },
      {
        title: i18n.gettext('合同编号'),
        label: contractInfo.contractId
      },
      {
        title: i18n.gettext('乙方名称'),
        label: contractInfo.partyaName
      },
      // {
      //   title: i18n.gettext('乙方注册地'),
      //   label: contractInfo.partyaRegisteAddr
      // },
      {
        title: i18n.gettext('乙方注册地址'),
        label: contractInfo.partyaAddr
      },
      {
        title: i18n.gettext('乙方邮箱'),
        label: contractInfo.partyaEmail
      },
      {
        title: i18n.gettext('乙方联系人'),
        label: contractInfo.partyaContact
      },
      {
        title: i18n.gettext('乙方联系人头衔'),
        label: PartyaTitle.val2text(contractInfo.partyaTitleType)
      },
      {
        title: i18n.gettext('乙方联系方式'),
        label: contractInfo.partyaPhone,
        isPhone: true
      },
      {
        title: i18n.gettext('平台配送'),
        content: platformSupport(contractInfo.deliveryType)
      },
      {
        title: i18n.gettext('平台配送佣金比例'),
        content: formatPercent(contractInfo.commissionJson ? get(JSON.parse(contractInfo.commissionJson), 'platform', '') : '')
      },
      {
        title: i18n.gettext('平台配送最低服务费'),
        content: contractInfo.deliveryMinRate && contractInfo.deliveryMinRate / 100
      },
      {
        title: i18n.gettext('自配送'),
        content: onselfSupport(contractInfo.deliveryType)
      },
      {
        title: i18n.gettext('自配送佣金比例'),
        content: formatPercent(contractInfo.commissionJson ? get(JSON.parse(contractInfo.commissionJson), 'onself', '') : '')
      },
      {
        title: i18n.gettext('商户主体类型'),
        content: contractInfo.contractorType ? ContractorTypeList.val2text(contractInfo.contractorType) : ''
      },
      {
        title: i18n.gettext('合同生效日期'),
        // 历史原因：按浏览器所在时区展示
        content: contractInfo.signatureTime && getFormatTimeByBrowserTimezone(contractInfo.signatureTime, 'yyyy-MM-dd') || ''
      }
      // {
      //   title: i18n.gettext('与滴滴平台签署独家协议'),
      //   content: DidiAgreement.val2text(contractInfo.didiAgreement)
      // }
    ]
  }
}
